import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { Register } from '@xanadu/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-texts',
    templateUrl: './texts.component.html',
    styleUrls: ['./texts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('texts')
export class TextsComponent extends InputComponent {
    metaText: any;
    texts: string[] = [];

    textsArray?: FormArray<any>;

    constructor(
        protected readonly builder: FormBuilder
    ) {
        super();

        const model = this.model();
        const meta = this.meta();

        if (model) {
            this.texts = model;
        }
        this.metaText = { name: 'Text', pattern: meta.pattern, maxLength: meta.maxLength };
        this.textsArray = this.builder.array([]);
        this.formGroup()?.addControl(this.meta().id, this.textsArray);
    }

    onAdd() {
        this.texts.push('');
    }

    onDelete(index: number) {
        this.textsArray?.removeAt(index);
        this.texts.splice(index, 1);
        this.formGroup()?.markAsDirty();
    }
}
